export const works = [
  {
    id: "02ec50f3",
    title: "Chill Pill",
    description: "Medication reminder for social good",
    image: "/image/work1.png",
    subImage: "/image/banner.png",
    bgImage: "/image/OqOPlapwvKfZk2CR.png",
    largeImage: "/image/IAH2eDBe4sS8P0dK.png",
    projectOverview: {
      title: "Project Overview",
      description:
        "Chill Pill is a medication reminder app operated by a non-profit organization. The organization provides a medium to help people with difficulties remembering or keeping up with medication. The Chill Pill app targets neurotypical and neurodivergent individuals with an age range of 18 to 70.",
      duration: "February 2023 to May 2023",
    },
    goal: {
      title: "The Goal",
      description:
        "Design an app that will help people set up medication reminders for themselves or dependents easily.",
    },
    problem: {
      title: "Problem",
      description:
        "There has been an increase in the nation’s older population since the early 20th century and so has the need for caregivers. These groups of people need help keeping up with the constant supply of medication with an accurate reminder. People with learning and neurological challenges may also struggle to keep up with medication. As life gets busier, people may have difficulties keeping up with daily demands and reminders.",
    },
    tools: {
      title: "Tools",
      description: "Adobe XD",
    },
    team: {
      title: "Team",
      description: "1 UX Designer",
    },
    role: {
      title: "My Role",
      description: "UX Designer, UX Researcher",
    },
    understandingUser: {
      title: "Understanding the user",
      description: [
        "User research",
        "Personas",
        "Problem statements",
        "Competitive audit",
        "Ideation",
      ],
    },
    timeline: {
      title: "Timeline",
      description:
        "Overall: 8+ weeks\nDiscovery & Research: 2+ weeks\nDesign & Testing: 6 weeks",
    },
    designProcess: {
      title: "My Design Process",
      steps: [
        "Understanding the user",
        "Starting the design",
        "Refining the design",
        "Responsive Design",
        "Going forward",
      ],
    },
    experiences: [
      { id: 1, title: "Tools", description: ["Adobe XD"] },
      { id: 2, title: "Team", description: ["1 UX designer"] },
      {
        id: 3,
        title: "My Role",
        description: ["UX Designer", "UX Researcher"],
      },
      {
        id: 4,
        title: "Timeline",
        description: [
          "Overall: 8+ weeks",
          "Discovery & Research: 2+ weeks",
          "Design & testing: 6 weeks",
        ],
      },
    ],
    steps: [
      { number: 1, text: "Understanding the user" },
      { number: 2, text: "Starting the design" },
      { number: 3, text: "Refining the design" },
      { number: 4, text: "Responsive Design" },
      { number: 5, text: "Going forward" },
    ],
    userResearch: {
      title: "User research: summary",
      description:
        "I conducted an interview to determine how often med reminder apps were used, basic apps used to set reminder  instead of apps with specifications, experience setting up a med reminder and how often medication was forgotten to be taken. Most interview participants had never used med reminder apps before. Although most of them did not have issues remembering medication, they affirmed that the med reminder app would be of great use and would save them the stress of having to remember. The users each gave a summary of what they expected to see in the medication reminder app.",
      image: "/image/mhA4l0oLHvILPF45.png",
    },
    personas: {
      title: "Personas",
      description:
        "To form a deep understanding of the pinpoints, behaviors and the experiences of users, I created 2 personas to represent the individuals in the two categories. I made use of feedback from interview to come up with the personas. Conducting the interview helped me eliminate some assumptions I had earlier about people and their use reminders for medication. I found out that people had variety of ways to remind themselves of their medication while some people did not need reminders. I initially assumed everyone used reminders or calendars meanwhile, one of the participant used visuals while the other set his medication on a visible spot or location.",
    },
    twoImages: {
      image1: "/image/resume1.png",
      image2: "/image/resume2.png",
    },
    competitive: {
      title: "Competitive audit",
      description:
        "Auditing some of the competitor's products pinpointed their setbacks and successes which were used as tools to start designing the low fidelity app",
    },
    ideation: {
      title: "Ideation",
      description:
        "I did a quick ideation to come up with strategies to solve the problems each personas identified in their day to day life. My focus was on the simplicity of easily adding a reminder",
      image: "/image/kh5XVPc0dPXhmOAZ.png",
    },
    startingTheDesign: {
      title: "Starting the design",
      description: [
        "Digital wireframes",
        "Low-fidelity prototype",
        "Usability studies",
      ],
    },
    digitalWireframes: {
      title: "Digital wireframes",
      description:
        "After ideating, I drafted a paper wireframe which was developed into a digital wireframe. While creating the wireframe, I put into consideration the wide variety of people to be accommodate. Therefore, simplicity was the focus",
      image: "/image/vFUi0LRpad8fQC2m.png",
    },
    lowFidelityPrototype: {
      title: "Low-fidelity prototype",
      description:
        "In preparation for the usability testing, I created a low fidelity prototype that connected the user flow of adding a medication easily and selecting to add a dependent’s medication.",
      image: "/image/7M9RBr6YGKLEkvMC.png",
    },
    refiningTheDesign: {
      title: "Refining the design",
      description: ["Mockups", "High-fidelity prototype", "Accessibility"],
    },
    usabilityStudyData: [
      { label: "Study type", value: "Unmoderated usability study" },
      { label: "Participants", value: "5 users" },
      { label: "Duration", value: "30 minutes per session" },
      { label: "Method", value: "Remote testing" },
      { label: "Goal", value: "Identify usability issues" },
    ],
    usabilityStudyFindingsSection: {
      title: "Usability Study: Findings",
      description:
        "These were the main findings I was able to come up with after the usability studies:",
    },
    usabilityStudyFindings: [
      {
        title: "1. Non-functional buttons",
        description:
          "People struggled with the dropdown buttons and schedule buttons.",
      },
      {
        title: "2. Gender Accommodation",
        description:
          "The male participants were unable to select their gender.",
      },
      {
        title: "3. Adding Person",
        description:
          "Adding a person was one of the top goals yet users struggled with it. People did not have specifications on whom to add.",
      },
    ],
    mockups: {
      title: "Mockups",
      description:
        "Based on the insights from the usability studies, I gave specific options on whom users could add. An add button to add person was confusing to most users.",
      image1: "/image/LwUqmM0UEq9Jwdvf.png",
      image2: "/image/vBmQSpFzP5O6PTfu.png",
    },
    highFidelityPrototype: {
      title: "High fidelity prototype",
      description:
        "You can write here as much as you want, this text will always look nice, whether you write longer paragraphs or just a few words. Click here and try it out.",
      image: "/image/VbT7Rv3EyjWwX5g5.png",
    },
    accessibilityConsiderations: {
      title: "Accessibility Considerations",
      points: [
        "1. Hierarchy and layout are logical and organized",
        "2. Readable fonts with enough white space",
        "3. Color contrast with text background and call to action buttons",
      ],
    },
    responsiveDesign: {
      title: "Responsive design",
      description: ["Information architecture", "Responsive design"],
    },
    sitemap: {
      title: "Sitemap",
      description:
        "After designing the mobile app, I proceeded into designing a responsive website for the mobile app. I used the Chillpill sitemap to guide the organizational structure .",
      image: "/image/HBLv9q4jMCkTYAs2.png",
    },
    responsivedesigns: {
      title: "Responsive designs",
      description:
        "The screen design includes phone, iPad and desktop. I adjusted the designs to meet the needs of users on each device and screen size.",
      image1: "/image/achhp8q7pZ72uusZ.png",
      image2: "/image/lm8r1MfzWBvqIvAY.png",
    },
    usabilityTesting: {
      title: "Usability Testing",
      description:
        "I created a fully-functional, high-fidelity prototype of the new flows using Axure. At the same time, we started recruiting subjects for the test who fit our criteria. We did 4 usability tests in the first round and 3 after iterating on the issues that we’ve identified.",
      issues: [
        {
          id: "01",
          title: "Issue 01",
          subtitle: "Your findings come here. ",
          findings:
            "What issue did you uncover through usability testing? How many times did this issue come up throughout the tests? How did the test subjects react to/describe this issue?",
          solutionTitle: "Solution 01",
          subtitle2: "Your solution idea comes here. ",
          solution:
            "What was the solution? How did you come up with the solution? How many times did you iterate on the design? How did you validate your solution?",
        },
        // Add more issues here if needed
      ],
    },
    goingForward: {
      title: "Going forward",
      description: ["Takeaways", "Next steps"],
    },
    takeaway: {
      title: "Takeaway",
      issues: [
        {
          id: "01",
          subtitle: "Impact: ",
          findings:
            "Users appreciated the option of adding dependents to medication reminder. The app is personalized but can still be used to help others. Most users claimed that they would prefer to used the app instead of alarms or calendars.",
          subtitle2: "What I learned:",
          solution:
            "I learned that my own ideas are not user centered., Conducting usability studies, avoiding bias and designing the apps to be user centered bring success in creating a good user experience",
        },
        // Add more issues here if needed
      ],
    },
    nextSteps: {
      title: "Next Steps",
      steps: [
        {
          id: 1,
          description:
            "1. Conduct a usability study to check the success of the app on reaching the goal of helping many easily create med reminders.",
        },
        {
          id: 2,
          description:
            "2. Add more educational resources about medication interference and continuously update the app based on user feedback.",
        },
        {
          id: 3,
          description:
            "3. Continuously making requests on how to improve the app and encourage people to make use of the app.",
        },
      ],
    },
    learnings: {
      title: "Learnings",
      description:
        "What new hard skill, soft skill, trick, or tool did you learn throughout the project? Was there any design practice you’ve tried for the first time? How did this project contribute to your growth as a designer? Did you have any preconceptions that were crushed? What did you learn throughout this project that’s influencing the way you design?",
    },
    appreciationText: {
      title: "Thank you for reading my case study!",
      description:
        "Thank you for taking the time to review my  work on the Chillpill app! If you would like to see more or get in touch, My contact information is provided below",
      moreInfo: "Email: eskaychinaza8@gmail.com contact me!",
      more: "...or just say hello on my social media.",
    },
  },
  {
    id: "025506e1",
    title: "The CHI App",
    description: "AI-powered voice assistant for accessibility",
    image: "/image/work2.png",
    subImage: "/image/fs2g29H4l7hOSinE.png",
    bgImage: "/image/GZE9KV93J0iAj0Mc.png",
    largeImage: "/image/VpgnuSlmO6oxuyZm.png",
    projectOverview: {
      title: "About the Chi App",
      description:
        "The Chi App is an independently selected project given by the Google Certificate Course. I played the special roles of a UX designer and UX researcher during the course of designing. The idea behind the Chi app was to bridge the communication gap between immigrants and technology in the United States.",
      // duration: "February 2023 to May 2023",
    },
    goal: {
      title: "The Goal",
      description:
        "Design an app that will allows users to have easy access to communicate and get feedback in native language and accent.",
    },
    problem: {
      title: "Problem",
      description:
        "Immigrants and non-English speakers in the USA lack accessibility to voice assistant apps that understand them speaks their language",
    },
    tools: {
      title: "Tools",
      description: "Figma",
    },
    team: {
      title: "Team",
      description: "1 UX Designer",
    },
    role: {
      title: "My Role",
      description: ["UX design", "UX research", "Workshop facilitator"],
    },
    understandingUser: {
      title: "Understanding the user",
      description: [
        "User research",
        "Personas",
        "Problem statements",
        "Competitive audit",
        "Ideation",
      ],
    },
    timeline: {
      title: "Timeline",
      description:
        "Overall: 8+ weeks\nDiscovery & Research: 2+ weeks\nDesign & Testing: 6 weeks",
    },
    designProcess: {
      title: "My Design Process",
      steps: [
        "Understanding the user",
        "Starting the design",
        "Refining the design",
        // "Responsive Design",
        "Going forward",
      ],
    },
    experiences: [
      { id: 1, title: "Tools", description: ["Adobe XD"] },
      { id: 2, title: "Team", description: ["1 UX designer"] },
      {
        id: 3,
        title: "My Role",
        description: ["UX Designer", "UX Researcher"],
      },
      {
        id: 4,
        title: "Timeline",
        description: [
          "Overall: 8+ weeks",
          "Discovery & Research: 2+ weeks",
          "Design & testing: 6 weeks",
        ],
      },
    ],
    steps: [
      { number: 1, text: "Understanding the user" },
      { number: 2, text: "Starting the design" },
      { number: 3, text: "Refining the design" },
      { number: 4, text: "Responsive Design" },
      { number: 5, text: "Going forward" },
    ],
    userResearch: {
      title: "User research: summary",
      description:
        "I conducted an interview to determine how often med reminder apps were used, basic apps used to set reminder  instead of apps with specifications, experience setting up a med reminder and how often medication was forgotten to be taken. Most interview participants had never used med reminder apps before. Although most of them did not have issues remembering medication, they affirmed that the med reminder app would be of great use and would save them the stress of having to remember. The users each gave a summary of what they expected to see in the medication reminder app.",
      image: "/image/mhA4l0oLHvILPF45.png",
    },
    personas: {
      title: "Personas",
      description:
        "To form a deep understanding of the pinpoints, behaviors and the experiences of users, I created 2 personas to represent the individuals in the two categories. I made use of feedback from interview to come up with the personas. Conducting the interview helped me eliminate some assumptions I had earlier about people and their use reminders for medication. I found out that people had variety of ways to remind themselves of their medication while some people did not need reminders. I initially assumed everyone used reminders or calendars meanwhile, one of the participant used visuals while the other set his medication on a visible spot or location.",
    },
    twoImages: {
      image1: "/image/resume1.png",
      image2: "/image/resume2.png",
    },
    competitive: {
      title: "Competitive audit",
      description:
        "Auditing some of the competitor's products pinpointed their setbacks and successes which were used as tools to start designing the low fidelity app",
    },
    ideation: {
      title: "Ideation",
      description:
        "I did a quick ideation to come up with strategies to solve the problems each personas identified in their day to day life. My focus was on the simplicity of easily adding a reminder",
      image: "/image/kh5XVPc0dPXhmOAZ.png",
    },
    startingTheDesign: {
      title: "Starting the design",
      description: [
        "Digital wireframes",
        "Low-fidelity prototype",
        "Usability studies",
      ],
    },
    digitalWireframes: {
      title: "Digital wireframes",
      description:
        "After ideating, I drafted a paper wireframe which was developed into a digital wireframe. While creating the wireframe, I put into consideration the wide variety of people to be accommodate. Therefore, simplicity was the focus",
      image: "/image/vFUi0LRpad8fQC2m.png",
    },
    lowFidelityPrototype: {
      title: "Low-fidelity prototype",
      description:
        "In preparation for the usability testing, I created a low fidelity prototype that connected the user flow of adding a medication easily and selecting to add a dependent’s medication.",
      image: "/image/7M9RBr6YGKLEkvMC.png",
    },
    refiningTheDesign: {
      title: "Refining the design",
      description: ["Mockups", "High-fidelity prototype", "Accessibility"],
    },
    usabilityStudyData: [
      { label: "Study type", value: "Unmoderated usability study" },
      { label: "Participants", value: "5 users" },
      { label: "Duration", value: "30 minutes per session" },
      { label: "Method", value: "Remote testing" },
      { label: "Goal", value: "Identify usability issues" },
    ],
    usabilityStudyFindingsSection: {
      title: "Usability Study: Findings",
      description:
        "These were the main findings I was able to come up with after the usability studies:",
    },
    usabilityStudyFindings: [
      {
        title: "1. Non-functional buttons",
        description:
          "People struggled with the dropdown buttons and schedule buttons.",
      },
      {
        title: "2. Gender Accommodation",
        description:
          "The male participants were unable to select their gender.",
      },
      {
        title: "3. Adding Person",
        description:
          "Adding a person was one of the top goals yet users struggled with it. People did not have specifications on whom to add.",
      },
    ],
    mockups: {
      title: "Mockups",
      description:
        "Based on the insights from the usability studies, I gave specific options on whom users could add. An add button to add person was confusing to most users.",
      image1: "/image/LwUqmM0UEq9Jwdvf.png",
      image2: "/image/vBmQSpFzP5O6PTfu.png",
    },
    highFidelityPrototype: {
      title: "High fidelity prototype",
      description:
        "You can write here as much as you want, this text will always look nice, whether you write longer paragraphs or just a few words. Click here and try it out.",
      image: "/image/VbT7Rv3EyjWwX5g5.png",
    },
    accessibilityConsiderations: {
      title: "Accessibility Considerations",
      points: [
        "1. Hierarchy and layout are logical and organized",
        "2. Readable fonts with enough white space",
        "3. Color contrast with text background and call to action buttons",
      ],
    },
    responsiveDesign: {
      title: "Responsive design",
      description: ["Information architecture", "Responsive design"],
    },
    sitemap: {
      title: "Sitemap",
      description:
        "After designing the mobile app, I proceeded into designing a responsive website for the mobile app. I used the Chillpill sitemap to guide the organizational structure .",
      image: "/image/HBLv9q4jMCkTYAs2.png",
    },
    responsivedesigns: {
      title: "Responsive designs",
      description:
        "The screen design includes phone, iPad and desktop. I adjusted the designs to meet the needs of users on each device and screen size.",
      image1: "/image/achhp8q7pZ72uusZ.png",
      image2: "/image/lm8r1MfzWBvqIvAY.png",
    },
    usabilityTesting: {
      title: "Usability Testing",
      description:
        "I created a fully-functional, high-fidelity prototype of the new flows using Axure. At the same time, we started recruiting subjects for the test who fit our criteria. We did 4 usability tests in the first round and 3 after iterating on the issues that we’ve identified.",
      issues: [
        {
          id: "01",
          title: "Issue 01",
          subtitle: "Your findings come here. ",
          findings:
            "What issue did you uncover through usability testing? How many times did this issue come up throughout the tests? How did the test subjects react to/describe this issue?",
          solutionTitle: "Solution 01",
          subtitle2: "Your solution idea comes here. ",
          solution:
            "What was the solution? How did you come up with the solution? How many times did you iterate on the design? How did you validate your solution?",
        },
        // Add more issues here if needed
      ],
    },
    goingForward: {
      title: "Going forward",
      description: ["Takeaways", "Next steps"],
    },
    takeaway: {
      title: "Takeaway",
      issues: [
        {
          id: "01",
          subtitle: "Impact: ",
          findings:
            "Users appreciated the option of adding dependents to medication reminder. The app is personalized but can still be used to help others. Most users claimed that they would prefer to used the app instead of alarms or calendars.",
          subtitle2: "What I learned:",
          solution:
            "I learned that my own ideas are not user centered., Conducting usability studies, avoiding bias and designing the apps to be user centered bring success in creating a good user experience",
        },
        // Add more issues here if needed
      ],
    },
    nextSteps: {
      title: "Next Steps",
      steps: [
        {
          id: 1,
          description:
            "1. Conduct a usability study to check the success of the app on reaching the goal of helping many easily create med reminders.",
        },
        {
          id: 2,
          description:
            "2. Add more educational resources about medication interference and continuously update the app based on user feedback.",
        },
        {
          id: 3,
          description:
            "3. Continuously making requests on how to improve the app and encourage people to make use of the app.",
        },
      ],
    },
    learnings: {
      title: "Learnings",
      description:
        "What new hard skill, soft skill, trick, or tool did you learn throughout the project? Was there any design practice you’ve tried for the first time? How did this project contribute to your growth as a designer? Did you have any preconceptions that were crushed? What did you learn throughout this project that’s influencing the way you design?",
    },
    appreciationText: {
      title: "Thank you for reading my case study!",
      description:
        "Thank you for taking the time to review my  work on the Chillpill app! If you would like to see more or get in touch, My contact information is provided below",
      moreInfo: "Email: eskaychinaza8@gmail.com contact me!",
      more: "...or just say hello on my social media.",
    },
  },
  {
    id: "026e282a",
    title: "Dollar Bank Website",
    description: "Human-centered banking experience",
    image: "/image/work3.png",
    subImage: "/image/banner.png",
    bgImage: "/image/GZE9KV93J0iAj0Nc.png",
    largeImage: "/image/PE902ABFVj3n3nnq.png",
    projectOverview: {
      title: "Project Overview",
      description:
        "The Dollar Bank is a responsive banking website that offers an easy banking experience to users. Dollar Bank was my second project during my UX design professional certificate course. I played the roles of a UX designer and UX researcher. During the process, it was discovered that Users are typically from the ages of 10 to 65 years of age. Most users are students and young professionals. Dollar Bank’s goal is to make the process of creating an account, fun and easy.",
    },
    goal: {
      title: "The Problem",
      description:
        "Banking website have cluttered and serious looks to them which makes user experience less fun and difficulties navigating.",
    },
    problem: {
      title: "Problem",
      description:
        "Banking website have cluttered and serious looks to them which makes user experience less fun and difficulties navigating.",
    },
    tools: {
      title: "Tools",
      description: "Adobe XD",
    },
    team: {
      title: "Team",
      description: "1 UX Designer",
    },
    role: {
      title: "My Role",
      description: "UX design lead",
    },
    understandingUser: {
      title: "My Responsibility",
      description: [
        "Conducting interviews",
        "Creating paper and digital wireframes, creating high fidelity and low fidelity prototype",
        "Iterating on design to meet accessibility",
        "Competitive audit",
        "Creating a responsive website.",
      ],
    },
    timeline: {
      title: "Project Duration",
      description: "November 2022 to February 2023.",
    },
    designProcess: {
      title: "My Design Process",
      steps: [
        "Understanding the user",
        "Starting the design",
        "Refining the design",
        // "Responsive Design",
        "Going forward",
      ],
    },
    experiences: [
      { id: 1, title: "Tools", description: ["Adobe XD"] },
      { id: 2, title: "Team", description: ["1 UX designer"] },
      {
        id: 3,
        title: "My Role",
        description: ["UX Designer", "UX Researcher"],
      },
      {
        id: 4,
        title: "Timeline",
        description: [
          "Overall: 8+ weeks",
          "Discovery & Research: 2+ weeks",
          "Design & testing: 6 weeks",
        ],
      },
    ],
    steps: [
      { number: 1, text: "Understanding the user" },
      { number: 2, text: "Starting the design" },
      { number: 3, text: "Refining the design" },
      { number: 4, text: "Responsive Design" },
      { number: 5, text: "Going forward" },
    ],
    userResearch: {
      title: "User research: summary",
      description:
        "I conducted an interview to determine how often med reminder apps were used, basic apps used to set reminder  instead of apps with specifications, experience setting up a med reminder and how often medication was forgotten to be taken. Most interview participants had never used med reminder apps before. Although most of them did not have issues remembering medication, they affirmed that the med reminder app would be of great use and would save them the stress of having to remember. The users each gave a summary of what they expected to see in the medication reminder app.",
      image: "/image/mhA4l0oLHvILPF45.png",
    },
    personas: {
      title: "Personas",
      description:
        "To form a deep understanding of the pinpoints, behaviors and the experiences of users, I created 2 personas to represent the individuals in the two categories. I made use of feedback from interview to come up with the personas. Conducting the interview helped me eliminate some assumptions I had earlier about people and their use reminders for medication. I found out that people had variety of ways to remind themselves of their medication while some people did not need reminders. I initially assumed everyone used reminders or calendars meanwhile, one of the participant used visuals while the other set his medication on a visible spot or location.",
    },
    twoImages: {
      image1: "/image/resume1.png",
      image2: "/image/resume2.png",
    },
    competitive: {
      title: "Competitive audit",
      description:
        "Auditing some of the competitor's products pinpointed their setbacks and successes which were used as tools to start designing the low fidelity app",
    },
    ideation: {
      title: "Ideation",
      description:
        "I did a quick ideation to come up with strategies to solve the problems each personas identified in their day to day life. My focus was on the simplicity of easily adding a reminder",
      image: "/image/kh5XVPc0dPXhmOAZ.png",
    },
    startingTheDesign: {
      title: "Starting the design",
      description: [
        "Digital wireframes",
        "Low-fidelity prototype",
        "Usability studies",
      ],
    },
    digitalWireframes: {
      title: "Digital wireframes",
      description:
        "After ideating, I drafted a paper wireframe which was developed into a digital wireframe. While creating the wireframe, I put into consideration the wide variety of people to be accommodate. Therefore, simplicity was the focus",
      image: "/image/vFUi0LRpad8fQC2m.png",
    },
    lowFidelityPrototype: {
      title: "Low-fidelity prototype",
      description:
        "In preparation for the usability testing, I created a low fidelity prototype that connected the user flow of adding a medication easily and selecting to add a dependent’s medication.",
      image: "/image/7M9RBr6YGKLEkvMC.png",
    },
    refiningTheDesign: {
      title: "Refining the design",
      description: ["Mockups", "High-fidelity prototype", "Accessibility"],
    },
    usabilityStudyData: [
      { label: "Study type", value: "Unmoderated usability study" },
      { label: "Participants", value: "5 users" },
      { label: "Duration", value: "30 minutes per session" },
      { label: "Method", value: "Remote testing" },
      { label: "Goal", value: "Identify usability issues" },
    ],
    usabilityStudyFindingsSection: {
      title: "Usability Study: Findings",
      description:
        "These were the main findings I was able to come up with after the usability studies:",
    },
    usabilityStudyFindings: [
      {
        title: "1. Non-functional buttons",
        description:
          "People struggled with the dropdown buttons and schedule buttons.",
      },
      {
        title: "2. Gender Accommodation",
        description:
          "The male participants were unable to select their gender.",
      },
      {
        title: "3. Adding Person",
        description:
          "Adding a person was one of the top goals yet users struggled with it. People did not have specifications on whom to add.",
      },
    ],
    mockups: {
      title: "Mockups",
      description:
        "Based on the insights from the usability studies, I gave specific options on whom users could add. An add button to add person was confusing to most users.",
      image1: "/image/LwUqmM0UEq9Jwdvf.png",
      image2: "/image/vBmQSpFzP5O6PTfu.png",
    },
    highFidelityPrototype: {
      title: "High fidelity prototype",
      description:
        "You can write here as much as you want, this text will always look nice, whether you write longer paragraphs or just a few words. Click here and try it out.",
      image: "/image/VbT7Rv3EyjWwX5g5.png",
    },
    accessibilityConsiderations: {
      title: "Accessibility Considerations",
      points: [
        "1. Hierarchy and layout are logical and organized",
        "2. Readable fonts with enough white space",
        "3. Color contrast with text background and call to action buttons",
      ],
    },
    responsiveDesign: {
      title: "Responsive design",
      description: ["Information architecture", "Responsive design"],
    },
    sitemap: {
      title: "Sitemap",
      description:
        "After designing the mobile app, I proceeded into designing a responsive website for the mobile app. I used the Chillpill sitemap to guide the organizational structure .",
      image: "/image/HBLv9q4jMCkTYAs2.png",
    },
    responsivedesigns: {
      title: "Responsive designs",
      description:
        "The screen design includes phone, iPad and desktop. I adjusted the designs to meet the needs of users on each device and screen size.",
      image1: "/image/achhp8q7pZ72uusZ.png",
      image2: "/image/lm8r1MfzWBvqIvAY.png",
    },
    usabilityTesting: {
      title: "Usability Testing",
      description:
        "I created a fully-functional, high-fidelity prototype of the new flows using Axure. At the same time, we started recruiting subjects for the test who fit our criteria. We did 4 usability tests in the first round and 3 after iterating on the issues that we’ve identified.",
      issues: [
        {
          id: "01",
          title: "Issue 01",
          subtitle: "Your findings come here. ",
          findings:
            "What issue did you uncover through usability testing? How many times did this issue come up throughout the tests? How did the test subjects react to/describe this issue?",
          solutionTitle: "Solution 01",
          subtitle2: "Your solution idea comes here. ",
          solution:
            "What was the solution? How did you come up with the solution? How many times did you iterate on the design? How did you validate your solution?",
        },
        // Add more issues here if needed
      ],
    },
    goingForward: {
      title: "Going forward",
      description: ["Takeaways", "Next steps"],
    },
    takeaway: {
      title: "Takeaway",
      issues: [
        {
          id: "01",
          subtitle: "Impact: ",
          findings:
            "Users appreciated the option of adding dependents to medication reminder. The app is personalized but can still be used to help others. Most users claimed that they would prefer to used the app instead of alarms or calendars.",
          subtitle2: "What I learned:",
          solution:
            "I learned that my own ideas are not user centered., Conducting usability studies, avoiding bias and designing the apps to be user centered bring success in creating a good user experience",
        },
        // Add more issues here if needed
      ],
    },
    nextSteps: {
      title: "Next Steps",
      steps: [
        {
          id: 1,
          description:
            "1. Conduct a usability study to check the success of the app on reaching the goal of helping many easily create med reminders.",
        },
        {
          id: 2,
          description:
            "2. Add more educational resources about medication interference and continuously update the app based on user feedback.",
        },
        {
          id: 3,
          description:
            "3. Continuously making requests on how to improve the app and encourage people to make use of the app.",
        },
      ],
    },
    learnings: {
      title: "Learnings",
      description:
        "What new hard skill, soft skill, trick, or tool did you learn throughout the project? Was there any design practice you’ve tried for the first time? How did this project contribute to your growth as a designer? Did you have any preconceptions that were crushed? What did you learn throughout this project that’s influencing the way you design?",
    },
    appreciationText: {
      title: "Thank you for reading my case study!",
      description:
        "Thank you for taking the time to review my  work on the Chillpill app! If you would like to see more or get in touch, My contact information is provided below",
      moreInfo: "Email: eskaychinaza8@gmail.com contact me!",
      more: "...or just say hello on my social media.",
    },
  },
  // {
  //   id: "02e463b5",
  //   title: "Apartment Swap App",
  //   description: "Apartment Recycle APP",
  //   image: "/image/work4.png",
  //   subImage: "/image/banner.png",
  //   // largeImage: "/image/PE902ABFVj3n3nnq.png",

  //   appreciationText: {
  //     title: "Thank you for reading my case study!",
  //     description:
  //       "Thank you for taking the time to review my  work on the Chillpill app! If you would like to see more or get in touch, My contact information is provided below",
  //     moreInfo: "Email: eskaychinaza8@gmail.com contact me!",
  //     more: "...or just say hello on my social media.",
  //   },
  // },
];

export const carouselImages = [
  "/image/carousel1.png",
  "/image/carousel2.png",
  "/image/carousel3.png",
];
